export interface CaptchaConfig {
  siteKey: string | undefined
  showCaptcha: boolean
  fallbackSiteKey?: string | undefined
}

/**
 * Captcha is enabled whenever a Cloudflare Turnstile site key is configured via env.
 * Removing the env var disables captcha (and reverts to the regular endpoints).
 */
export const useCaptchaConfig = () => {
  const hasCaptchaSiteKey = Boolean(
    process.env.REACT_APP_CLOUDFLARE_CAPTCHA_SITE_KEY
  )
  const isCaptchaEnabled = hasCaptchaSiteKey

  const captchaConfig: CaptchaConfig = {
    siteKey: process.env.REACT_APP_CLOUDFLARE_CAPTCHA_SITE_KEY,
    showCaptcha: isCaptchaEnabled,
    fallbackSiteKey: process.env.REACT_APP_CLOUDFLARE_CAPTCHA_SITE_KEY_FALLBACK,
  }

  return {
    isCaptchaEnabled,
    captchaConfig,
  } as const
}
